import { MdHistory, MdList } from "react-icons/md";
import useModalPlanejamentoOperacoes from "../../../hooks/useModalPlanejamentoOperacoes"
import { Container, SubModulesNavHeader, Button } from "./styles";

export function TabbarModal() {
    const { menuOption, setMenuOption } = useModalPlanejamentoOperacoes();

    const handleToggleId = (item: any) => {
        setMenuOption(item?.id);
    }

    const list = [
        {
            name: "Operações",
            id: "operacoes",
            icon: MdList,
        },
        {
            name: "Histórico de Alterações",
            id: "historico",
            icon: MdHistory
        }
    ];

    return (
        <Container>
            <SubModulesNavHeader>
                {
                    list.map((item, index) => (
                        <Button
                            active={menuOption === item.id}
                            key={index} onClick={() => handleToggleId(item)}
                        >
                            <item.icon size={18} />
                            <span>{item.name}</span>
                        </Button>
                    ))
                }
            </SubModulesNavHeader>
        </Container>
    )
}